import React from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemVideo} from './datatable/list';
import { Danhmuc, Reception } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from 'constants/message';
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {Input, DropDown} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';
import { ShowIf } from 'components/utils';
import {checkServerLive, LimitFileSize, LimitVideoType, LimitPhotoType, LimitVideoFileSize} from 'constants/config';

class Video extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      isValid: true,
      videoId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false,

      danhMucVideoList: [],
      danhMucVideo: '',
      loaiVideoList: [],
      loaiVideo: '',
      progressAvatar: 0,
      progressVideo: 0,
      ten: '',
      tenFileAvatar: '',
      tenFileVideo: '',
      urlFileAvatar: '',
      urlFileVideo: '',
      videoAvatarInvalid: false,
      videoFileInvalid: false
    };
  }

  componentDidMount() {
    this.getListData();
    this.getDanhMucVideo();
    this.getLoaiVideo();
  }

  getLoaiVideo() {
    let params = {
      page: 0,
      size: 999
    }
    Danhmuc.actions.getLoaiVideo.request(null, params).then(res => {
     if (res.data) {
        this.setState({loaiVideoList: res.data});
      } else {
        this.setState({loaiVideoList: []});
      }
    });
  }

  getDanhMucVideo() {
    let params = {
      page: 0,
      size: 999
    }
    Danhmuc.actions.getDanhMucVideo.request(null, params).then(res => {
     if (res.data && res.data._embedded) {
        this.setState({danhMucVideoList: res.data._embedded.danhMucVideos});
      } else {
        this.setState({danhMucVideoList: []});
      }
    });
  }

  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getVideo.request(null, params).then(res => {
     if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.videos,
          pageData: res.data.page,
          tableLoading: false,
          searchLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false,
          searchLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  createCategory() {
    if (this.checkValidate()) {
      let params = {
        ten: this.state.ten.trim(),
        danhMucVideo: {id: this.state.danhMucVideo},
        loaiVideo: this.state.loaiVideo
      };
      if (this.state.tenFileAvatar) {
        params.tenFileAvatar = this.state.tenFileAvatar;
        params.urlFileAvatar = this.state.urlFileAvatar;
      }
      if (this.state.tenFileVideo) {
        params.tenFileVideo = this.state.tenFileVideo;
        params.urlFileVideo = this.state.urlFileVideo;
      }

      this.setState({buttonLoading: true});
      if (this.state.videoId) {
        Danhmuc.actions.updateVideo.request({id: this.state.videoId},params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        Danhmuc.actions.postVideo.request('',params).then(res => {
          this.getListData();
          this.toggleDialog();
           Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  componentWillUnmount() {
    this.props.validators['danhMuc'] = [];
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(categoryId) {
    if (categoryId){
      this.setState({buttonLoading: true});
      Danhmuc.actions.deleteVideo.request({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delVideoSuccess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
      });
    }
  }
  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    if (!this.state.tenFileVideo) {
      pass = false;
      this.setState({videoFileInvalid: true});
    }
    if (!this.state.tenFileAvatar) {
      pass = false;
      this.setState({videoAvatarInvalid: true});
    }
    return pass;
  }

  toggleDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.toggleDialog();
    this.setState({
      isValid: true,
      videoId: '',
      ten: '',
      danhMucVideo: '',
      loaiVideo: '',
      progressAvatar: 0,
      progressVideo: 0,
      tenFileAvatar: '',
      tenFileVideo: '',
      urlFileAvatar: '',
      urlFileVideo: '',
      videoFileInvalid: false,
      videoAvatarInvalid: false
    });
  }

  openUpdateCategory(item) {
    this.toggleDialog();
    this.setState({
      videoId: item.videoId,
      ten: item.ten,
      danhMucVideo: item.danhMucVideoInfo ? item.danhMucVideoInfo.danhMucVideoId : '',
      loaiVideo: item.loaiVideo,
      progressAvatar: 0,
      progressVideo: 0,
      tenFileAvatar: item.tenFileAvatar,
      tenFileVideo: item.tenFileVideo,
      urlFileAvatar: item.urlFileAvatar,
      urlFileVideo: item.urlFileVideo,
      isValid: true,
      videoFileInvalid: false,
      videoAvatarInvalid: false
    });
  }

  uploadFile(type, e) {
    if (e.target.files[0]) {
      let fileName = e.target.files[0].name;
      let ext = fileName.split('.').pop().toLowerCase();
      let fileSize = e.target.files[0].size;
      if ((type == 'video' && LimitVideoType.indexOf(ext) == -1) || (type == 'avatar' && LimitPhotoType.indexOf(ext) == -1)) {
        if (type == 'avatar')
          Toastr(msg.filePhotoErr, 'warning');
        else
          Toastr(msg.fileVideoTypeErr, 'warning');
      } else if ((type == 'avatar' && fileSize > LimitFileSize*1024*1024) || (type == 'video' && fileSize > LimitVideoFileSize*1024*1024)) {
        if (type == 'avatar')
          Toastr(msg.fileSizeErr, 'warning');
        else
          Toastr(msg.fileVideoSizeErr, 'warning');
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
      } else {
        let params = {field: 'file', file: e.target.files[0]};

        params.progress = (progress)=>{
          let progressBar = Math.round( (progress.loaded * 100) / progress.total );
          if (type == 'video') {
            this.setState({progressVideo: progressBar});
          } else {
            this.setState({progressAvatar: progressBar});
          }
        }

        Reception.actions.postFileUpload.request('', params).then(res => {
          let checkURL = '';
          if (res && res.data && !checkServerLive) {
            checkURL = res.data;
          } else if (res && res.data && checkServerLive) {
            checkURL = res.data.id;
          }
          if (type == 'video') {
            this.setState({
              progressVideo: 0,
              tenFileVideo: fileName,
              urlFileVideo: checkURL
            });
          } else {
            this.setState({
              progressAvatar: 0,
              tenFileAvatar: fileName,
              urlFileAvatar: checkURL
            });
          }
        });
      }
    }
  }

  handleRemove(type) {
    if (type == 'video') {
      this.setState({tenFileVideo: '', urlFileVideo: ''});
    } else {
      this.setState({tenFileAvatar: '', urlFileAvatar: ''});
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Video</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('DANHMUCVIDEO_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <Search parents={this}/>
            <DataTable
              header = {header.categoryGroup.video}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideExport
              parent= {this}
              search = {this.state.search}
              tableLoading = {this.state.tableLoading}
            >
              <RowItemVideo/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this)}
            title={this.state.addType == 2 ? 'Chỉnh sửa video' : 'Thêm mới video'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body">
              <DropDown className="col-6" label="Danh mục:" options={this.state.danhMucVideoList} keyName="danhMucVideoId" valueName="ten" placeholder selectedValue={this.state.danhMucVideo}
                onChange={this.onChange.bind(this, 'danhMucVideo')} bindValidator={this} require channel="danhMuc"/>
              <DropDown className="col-6" label="Loại video:" options={this.state.loaiVideoList} keyName="giaTri" valueName="ten" placeholder selectedValue={this.state.loaiVideo}
                onChange={this.onChange.bind(this, 'loaiVideo')} bindValidator={this} require channel="danhMuc"/>
              <Input className="col-100" label="Tên" value={this.state.ten} require={true} maxLength={40} onChange={this.onChange.bind(this, 'ten')}
                bindValidator={this} channel="danhMuc"/>
              <div className="col-100 mb18">
                <label className="ip-label">Hình đại diện của video:<span className="text-required">&nbsp;*</span></label>
                <ShowIf condition={this.state.tenFileAvatar == '' && this.state.progressAvatar == 0}>
                  <div className="wrap-link-todo link-attach col-3">
                    <div className="upload_file_content">
                      <input type="file" className="upload" onChange={this.uploadFile.bind(this, 'avatar')}/>
                      <span htmlFor="file">Tải lên tập tin</span>
                    </div>
                  </div>
                </ShowIf>
                <ShowIf condition={this.state.tenFileAvatar != ''}>
                  <div className="link-attach">
                    {this.state.tenFileAvatar}
                    <Link className="itt-delete ml5" onClick={this.handleRemove.bind(this, 'avatar')}>Xóa</Link>
                  </div>
                </ShowIf>
                <ShowIf condition={this.state.progressAvatar > 0}>
                  <div className="pt-progress-bar progress-upload pt-intent-primary">
                    <div className="pt-progress-meter" style={{width: `${this.state.progressAvatar}%`}} />
                  </div>
                </ShowIf>
              </div>
              {
                (this.state.videoAvatarInvalid && this.state.tenFileAvatar == '') &&
                <div className="pt-form-helper-text ml5 mb18">Bạn không được bỏ trống trường này.</div>
              }
              <div className="col-100 mb18">
                <label className="ip-label">Tệp Video:<span className="text-required">&nbsp;*</span></label>
                <ShowIf condition={this.state.tenFileVideo == '' && this.state.progressVideo == 0}>
                  <div className="wrap-link-todo link-attach col-3">
                    <div className="upload_file_content">
                      <input type="file" className="upload" onChange={this.uploadFile.bind(this, 'video')}/>
                      <span htmlFor="file">Tải lên tập tin</span>
                    </div>
                  </div>
                </ShowIf>
                <ShowIf condition={this.state.tenFileVideo != ''}>
                  <div className="link-attach">
                    {this.state.tenFileVideo}
                    <Link className="itt-delete ml5" onClick={this.handleRemove.bind(this, 'video')}>Xóa</Link>
                  </div>
                </ShowIf>
                <ShowIf condition={this.state.progressVideo > 0}>
                  <div className="pt-progress-bar progress-upload pt-intent-primary">
                    <div className="pt-progress-meter" style={{width: `${this.state.progressVideo}%`}} />
                  </div>
                </ShowIf>
              </div>
              {
                (this.state.videoFileInvalid && this.state.tenFileVideo == '') &&
                <div className="pt-form-helper-text ml5 mb18">Bạn không được bỏ trống trường này.</div>
              }
            </div>
            <div className="pt-dialog-footer">
              <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)}>
                <span>{this.state.videoId ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

Video.defaultProps = {
  validators: {}
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/modules/category/Video.jsx